export const DEFAULT_START_HOUR = '9:00';
export const DEFAULT_END_HOUR = '17:00';
